/**
 * KAN-834: вход менеджера в приложение (PWA) по одноразовой ссылке.
 *
 *   POST /api/v1/managers/{id}/app-link/  - {url, expires_at}: ссылка входа (владелец и оператор;
 *                                           роли MANAGER 403; менеджер в архиве или вход отключён 400 {detail})
 *   POST /api/v1/auth/app-link/ {uid, token} - тело как у POST /api/v1/auth/login/
 *                                           {access, refresh, user}; 400 {detail}: ссылка недействительна
 */
import apiClient from './client';

/** Ссылка входа в приложение (одноразовая, действует 3 дня). */
export interface ManagerAppLink {
  url: string;
  expires_at: string;
}

/** Ответ обмена ссылки: та же форма, что у входа по паролю. */
export interface AppLinkLoginResponse {
  access: string;
  refresh: string;
  user: { id: string; role?: string | null } & Record<string, unknown>;
}

export const appLinkApi = {
  async createManagerAppLink(managerId: string): Promise<ManagerAppLink> {
    const res = await apiClient.post<ManagerAppLink>(`/api/v1/managers/${managerId}/app-link/`);
    return res.data;
  },

  async exchange(uid: string, token: string): Promise<AppLinkLoginResponse> {
    const res = await apiClient.post<AppLinkLoginResponse>('/api/v1/auth/app-link/', { uid, token });
    return res.data;
  },
};
